import { ChangeDetectorRef, Component, OnInit, AfterContentChecked, LOCALE_ID } from '@angular/core';
import { AuthService } from '../services/auth.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import config from '../services/config';
import moment from 'moment';
import momentTZ from 'moment-timezone';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ReBokingComponent } from '../new-booking/re-boking/re-boking.component';
import {  MAT_DATE_LOCALE } from '@angular/material/core';
import { catchError, forkJoin, map, Observable, of } from 'rxjs';


@Component({
    selector: 'app-bookin',
    templateUrl: './bookin.component.html',
    styleUrls: ['./bookin.component.scss'],
    providers: [{ provide: LOCALE_ID, useValue: 'es' }, { provide: MAT_DATE_LOCALE, useValue: 'es-ES' }],
    standalone: false
})

export class BookinComponent implements OnInit, AfterContentChecked {

  bookings = [];
  bookingsUpcoming = [];
  bookingsToBeCancelled = [];
  bookingsPast = [];
  today = new Date();
  time_zone = "";
  maxRangeDate = new Date().getTime() + (24 * 60 * 60 * 1000);
  index = 0;
  showGetMore = true;
  isLoading = false;
  loadingToday = false;
  loadingUpcoming = false;
  loadingPast = false;

  constructor(
    private service: AuthService,
    private router: Router,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    var resolvedOptions = Intl.DateTimeFormat().resolvedOptions();
    this.time_zone = this.service.user.time_zone ? this.service.user.time_zone : resolvedOptions.timeZone;
    this.refresh();
    this.comprobarId();

    //this.getBookings();
    //this.getBookingsUpcoming();
    //this.getBookingsPast();
  }

  comprobarId(){
    this.route.queryParams.subscribe(params => {
      const idParam = params['id'];
      if (idParam) {
        this.service.confirmAppointment(idParam).subscribe((d: any) => {          
          this.refreshAllSections();
          Swal.fire({
            icon: 'success',
            title: '¡Tu sesión ha sido agendada!',
            text: "Muy pronto recibirás confirmación de tu terapeuta",
            showConfirmButton: true,
            confirmButtonText: "ok",
            confirmButtonColor:'#023171',
          })
        }, err => { 
          console.log(err) 
          Swal.fire({
            icon: 'error',
            title: 'Ocurrió un error durante el proceso de pago',
            text: "Intenta de nuevo más tarde, o checa con tu banco para más información.",
            showConfirmButton: true,
            confirmButtonText: "ok",
            confirmButtonColor:'#023171',
          });
        });
      }
    });
  }

  ngAfterContentChecked(){
    // this.bookings.forEach( (elem, index) =>{
    //   let img = elem.doctor_user_id.photo_media_id;
    //   if( typeof img === 'number' ){
    //     this.service.getImgId(img).subscribe((d: any) => {
    //       this.bookings[index].doctor_user_id.photo_media_id = d.data.items[0].url
    //     });
    //   }
    // })

    // this.bookingsUpcoming.forEach( (elem, index) =>{
    //   let img = elem.doctor_user_id.photo_media_id;
    //   if( typeof img === 'number' ){
    //     this.service.getImgId(img).subscribe((d: any) => {
    //       this.bookingsUpcoming[index].doctor_user_id.photo_media_id = d.data.items[0].url
    //     });
    //   }
    // })

    // this.bookingsPast.forEach( (elem, index) =>{
    //   let img = elem.doctor_user_id.photo_media_id;
    //   if( typeof img === 'number' ){
    //     this.service.getImgId(img).subscribe((d: any) => {
    //       this.bookingsPast[index].doctor_user_id.photo_media_id = d.data.items[0].url
    //     });
    //   }
    // })
  }

  changeTab($event){
    this.index = $event.index;
    switch(this.index){
      case 0: if(this.bookings.length == 0)this.getBookings(); break;
      case 1: this.getBookingsUpcoming();break;
      case 2: if(this.bookingsPast.length == 0)this.getBookingsPast();break;
    }
  }

  getBookings() {
    this.loadingToday = true;
    this.bookings = [];
    this.refreshView();

    forkJoin({
      scheduled: this.loadAppointmentItems(this.service.datesScheduled(this.service.user.id), 'No se pudieron cargar tus sesiones.'),
      toConfirm: this.loadAppointmentItems(this.service.datesToBeConfirmed(this.service.user.id), 'No se pudieron cargar las citas por confirmar.'),
      inProgress: this.loadAppointmentItems(this.service.datesInProgress(this.service.user.id), 'No se pudieron cargar las sesiones en progreso.')
    }).subscribe(({ scheduled, toConfirm, inProgress }) => {
      this.addActiveBookings([...scheduled, ...toConfirm, ...inProgress]);
      this.loadingToday = false;
      this.refreshView();
    });
  }

  getBookingsUpcoming() {
    this.loadingUpcoming = true;
    this.bookingsUpcoming = [];
    this.bookingsToBeCancelled = [];
    this.refreshView();

    forkJoin({
      scheduled: this.loadAppointmentItems(this.service.datesScheduled(this.service.user.id), 'No se pudieron cargar tus próximas citas.'),
      toConfirm: this.loadAppointmentItems(this.service.datesToConfirm(this.service.user.id), 'No se pudieron cargar las citas por confirmar.'),
      toCancel: this.loadAppointmentItems(this.service.datesToBeCancelled(this.service.user.id), 'No se pudieron cargar las solicitudes de cancelación.', true)
    }).subscribe(({ scheduled, toConfirm, toCancel }) => {
      this.addUpcomingBookings([...scheduled, ...toConfirm]);
      this.bookingsToBeCancelled = this.sortBookings(toCancel.map((elem) => this.normalizeBooking(elem)));
      this.loadingUpcoming = false;
      this.refreshView();
    });
  }

  getBookingsPast() {
    const firstLoad = this.bookingsPast.length === 0;
    this.loadingPast = firstLoad;
    this.isLoading = !firstLoad;
    this.refreshView();

    forkJoin({
      finished: this.loadAppointmentItems(this.service.endDatesFinish(10, this.bookingsPast.length), 'No se pudieron cargar las sesiones anteriores.'),
      cancelled: this.loadAppointmentItems(this.service.datesCancelled(this.service.user.id), 'No se pudieron cargar las citas canceladas.', true)
    }).subscribe(({ finished, cancelled }) => {
      const items = [...finished, ...cancelled].map((elem) => this.normalizeBooking(elem));
      if (finished.length === 0 && cancelled.length === 0) this.showGetMore = false;
      this.bookingsPast = this.sortBookings(this.mergeBookings(this.bookingsPast, items)).reverse();
      this.loadingPast = false;
      this.isLoading = false;
      this.refreshView();
    });

  }

  cheackDates(date: string = "") {
    let tz = momentTZ.tz(date, this.time_zone).clone().tz(this.time_zone).format();
    let tzDay = momentTZ.tz(this.today, this.time_zone).format();

    return !((Date.parse(tz) - 300000) <= Date.parse(tzDay));
  }

  canEnterVideo(booking: any) {
    if (!booking?.start_at) return false;

    const status = booking?.status;
    const blockedStatuses = [
      'to_be_confirmed_by_therapist',
      'to_be_cancelled_by_therapist',
      'appointment_cancelled',
      'appointment_finished'
    ];
    const connectedStatuses = [
      'appointment_in_progress',
      'connected',
      'one_connected',
      'two_connected',
      'both_connected'
    ];

    if (blockedStatuses.includes(status)) return false;
    if (connectedStatuses.includes(status)) return true;

    const start = momentTZ.tz(booking.start_at, this.time_zone);
    const now = momentTZ.tz(this.time_zone);
    return now.isSameOrAfter(start.clone().subtract(5, 'minutes'));
  }

  getVideoAccessText(booking: any) {
    if (this.canEnterVideo(booking)) {
      return 'La videollamada ya está disponible para esta sesión.';
    }

    if (!booking?.start_at) {
      return 'El acceso se habilitará cuando se confirme la hora de la sesión.';
    }

    const accessAt = momentTZ.tz(booking.start_at, this.time_zone).subtract(5, 'minutes');
    return `El acceso se habilita 5 minutos antes, a las ${accessAt.format('HH:mm')}.`;
  }

  checkReDate(date){
    return (date < this.maxRangeDate);
  }

  goSession(b) {

    this.service.conectDate(b.patient_user_id.id, b.id).subscribe((d: any) => {//doctor_user_id.id
      let decData = this.service.parseEncryptedResponse(d, "private");

      //console.log(decData.data.items[0])
      config.SESSION_ID = decData.data.items[0].conference_session_token;
      config.TOKEN = decData.data.items[0].token;
      this.router.navigate(['/panel/video', b.id]);
    }, err => {
      this.service.handleRequestError(err, {
        fallback: 'No pudimos iniciar la sesión. Intenta de nuevo en unos minutos.'
      });
    })
  }

  goChat(booking) {
    this.router.navigate(['/panel/chat']);
  }

  returnStatus(s) {
    let status = s;
    switch (s) {
      case 'scheduled_appointment':
        status = "Cita agendada";
        break;
      case 'appointment_in_progress':
        status = "En progreso"
        break;
      case 'connected':
      case 'one_connected':
        status = "Terapeuta conectado";
        break;
      case 'two_connected':
      case 'both_connected':
        status = "Sesión en curso";
        break;
      case 'to_be_confirmed_by_therapist':
        status = "Por confirmar"
        break;
      case 'to_be_cancelled_by_therapist':
        status = "Por confirmar cancelación";
        break;
      case 'appointment_cancelled':
        status = 'Cita cancelada'
        break;
      case 'appointment_finished':
        status = 'Finalizada';
        break;
      default:
        status = s;
        break;
    }

    return status

  }

  addActiveBookings(items: any[]) {
    const todayBookings = [];
    const upcomingBookings = [];

    items
      .map((elem) => this.normalizeBooking(elem))
      .forEach((booking) => {
        if (this.isTodayBooking(booking)) {
          todayBookings.push(booking);
          return;
        }

        if (this.isFutureBooking(booking)) {
          upcomingBookings.push(booking);
        }
      });

    this.bookings = this.sortBookings(this.mergeBookings(this.bookings, todayBookings));
    this.bookingsUpcoming = this.sortBookings(this.mergeBookings(this.bookingsUpcoming, upcomingBookings));
  }

  addUpcomingBookings(items: any[]) {
    const upcomingBookings = items
      .map((elem) => this.normalizeBooking(elem))
      .filter((booking) => this.isFutureBooking(booking));

    this.bookingsUpcoming = this.sortBookings(this.mergeBookings(this.bookingsUpcoming, upcomingBookings));
  }

  normalizeBooking(booking: any) {
    const doctor = booking?.doctor_user_id || booking?.doctor || {};

    return {
      ...booking,
      doctor_user_id: doctor,
      doctor: booking?.doctor || doctor,
      start_at: momentTZ(booking.start_at).tz(this.time_zone).format()
    };
  }

  mergeBookings(current: any[], incoming: any[]) {
    const map = new Map();
    [...current, ...incoming].forEach((booking) => {
      const key = booking?.id || `${booking?.start_at}-${booking?.doctor_user_id?.id || booking?.doctor?.id}`;
      map.set(key, booking);
    });

    return Array.from(map.values());
  }

  sortBookings(bookings: any[]) {
    return [...bookings].sort((a, b) => moment(a.start_at).valueOf() - moment(b.start_at).valueOf());
  }

  isTodayBooking(booking: any) {
    return momentTZ.tz(booking.start_at, this.time_zone).isSame(momentTZ.tz(this.time_zone), 'day');
  }

  isFutureBooking(booking: any) {
    return momentTZ.tz(booking.start_at, this.time_zone).isAfter(momentTZ.tz(this.time_zone), 'day');
  }

  getDoctorName(booking: any) {
    const doctor = booking?.doctor_user_id || booking?.doctor || {};
    return `${doctor.first_name || ''} ${doctor.last_name || ''}`.trim() || 'Terapeuta';
  }

  getDoctorPhone(booking: any) {
    const doctor = booking?.doctor_user_id || booking?.doctor || {};
    return doctor.phone || 'Contacto no disponible';
  }

  getDoctorPhoto(booking: any) {
    const doctor = booking?.doctor_user_id || booking?.doctor || {};
    const photo = booking?.doctor?.photo_media_id || doctor?.photo_media_id;

    if (photo && typeof photo === 'object' && photo.url) {
      return photo.url;
    }

    return './assets/img/profile.jpg';
  }

  getStatusClass(status: string) {
    switch (status) {
      case 'scheduled_appointment':
        return 'status-scheduled';
      case 'appointment_in_progress':
      case 'connected':
      case 'one_connected':
      case 'two_connected':
      case 'both_connected':
        return 'status-live';
      case 'to_be_confirmed_by_therapist':
        return 'status-pending';
      case 'to_be_cancelled_by_therapist':
        return 'status-cancel-pending';
      case 'appointment_cancelled':
        return 'status-cancelled';
      case 'appointment_finished':
        return 'status-finished';
      default:
        return 'status-neutral';
    }
  }

  canManageBooking(booking: any) {
    return !this.checkReDate(booking.start_at);
  }

  private loadAppointmentItems(request$: Observable<any>, fallback: string, ignoreNotFound = false): Observable<any[]> {
    return request$.pipe(
      map((d: any) => {
        const decData = this.service.parseEncryptedResponse(d, "private");
        return decData?.data?.items || [];
      }),
      catchError((err) => {
        if (!ignoreNotFound || err?.status !== 404) {
          this.service.handleRequestError(err, {
            showModal: false,
            fallback
          });
        }

        return of([]);
      })
    );
  }

  private refreshView() {
    this.cdr.detectChanges();
  }

  refresh(){
    this.refreshAllSections();
  }

  private refreshAllSections(){
    this.showGetMore = true;
    this.bookingsPast = [];
    this.getBookings();
    this.getBookingsUpcoming();
    this.getBookingsPast();
  }

  reDateBooking(doc){
    //console.log(doc)
    const dialogRef = this.dialog.open(ReBokingComponent, {
      width: '800px',
      height: '600px',
      data: doc
    });
    this.refresh()
  }

  setDefaultPic(event){
    event.target.src = './assets/icono.png';
  }

  showCancel(appointment, mode = 1){
    //console.log(appointment)
    if(mode === 1){
      Swal.fire({
        title: 'Cancelar',
        text: 'Puedes cancelar hasta 24 horas antes de tu cita',
        icon: 'error',
        confirmButtonText: 'Confirmar',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        showConfirmButton: true,
        confirmButtonColor:'#023171',
        preConfirm:() => {
          this.cancelBooking(appointment);
        }
      })
    } else {
      Swal.fire({
        title: 'Cancelar',
        text: 'Se cancelará la solicitud de videollamada que se hizo al terapeuta ' + appointment.doctor.first_name + ' ' + appointment.doctor.last_name + ', ¿Está seguro de que desea continuar?',
        icon: 'error',
        confirmButtonText: 'Confirmar',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        showConfirmButton: true,
        confirmButtonColor:'#023171',
        preConfirm:() => {
          this.cancelBooking(appointment);
        }
      })
    }
  }

  cancelBooking(appointment){
    let body = {
      status:"to_be_cancelled_by_therapist",
    }
    //console.log(appointment)
    this.service.cancelBooking(body, appointment).subscribe( (d:any) =>{
      let decData = this.service.parseEncryptedResponse(d, "private");
      if(appointment.promo_code === null){
        Swal.fire({
          icon: 'success',
          title: 'Su cita ha sido cancelada.',
          text: "Su terapeuta será notificado.\nVerá su reembolso reflejado en un máximo de 72 horas.",
          showConfirmButton: true,
          confirmButtonText: "ok",
          confirmButtonColor:'#023171',
        });
        this.refresh()
        return
      }
      Swal.fire({
        icon: 'success',
        title: 'Su cita ha sido cancelada.',
        text: "Su terapeuta será notificado.",
        showConfirmButton: true,
        confirmButtonText: "ok",
        confirmButtonColor:'#023171',
      });
      this.refresh()
    },err=>{
      this.service.handleRequestError(err, {
        fallback: 'No pudimos cancelar la cita. Intenta de nuevo en unos minutos.'
      });
      this.refresh()
    });
  }

}
